import { TAG_MANAGER_ID } from '@/config';

type GTMType = {
  id: string;
  dataLayerName: string;
};

const GTM: GTMType = {
  id: TAG_MANAGER_ID,
  dataLayerName: 'dataLayer',
};

export default GTM;
